import { render } from "./KingdomInvitation.vue?vue&type=template&id=3ca813fa"
import script from "./KingdomInvitation.vue?vue&type=script&lang=js"
export * from "./KingdomInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/windowOverlay/KingdomInvitation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ca813fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ca813fa', __exports__)) {
    api.reload('3ca813fa', __exports__)
  }
  
  module.hot.accept("./KingdomInvitation.vue?vue&type=template&id=3ca813fa", () => {
    api.rerender('3ca813fa', render)
  })

}


export default __exports__